var KEYS  = require('../../keys/Keys');
var AXIOS = require('axios');


export {GetFirmwareInfoAsync as InvokeAsync , GetFirmwareInfoSync as InvokeSync}

async function GetFirmwareInfoAsync(LoginToken,FirmwareUUID)
{
    var GetFirmwareInfoPromise = new Promise((resolve, reject) => {
        GetFirmwareInfoSync(LoginToken,FirmwareUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetFirmwareInfoPromise;
}

function GetFirmwareInfoSync(LoginToken,FirmwareUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/User/GetFirmwareInfo',                
        data  : {
            LoginToken      : LoginToken,
            FirmwareUUID    : FirmwareUUID,            
            AppID           : KEYS.AWS_APPID              
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
